export default __webpack_public_path__ + "static/SRUS P123 - Product Specifications & Technical Data-bbf3c05f7fbb74d57eaa645006d1a4c3.pdf";